// this file is automatically generated on build by git.version.ts script

export const versions = {
  version: '0-dev',
  revision: '0-dev',
  branch: '0-dev',
};
